/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { GContextTypes } from '../../types';
import { GlobalContext } from '../../contexts';
import { useReactToPrint } from 'react-to-print';
import { SupplierContractPrint } from '../../print';
import PrintDownloadSupplier from './PrintDownloadSupplier';

const PopupSupplierFormView = ({
  open,
  onClose,
  row,
  theme,
  company,
  suppliers,
}: any) => {
  const {
    translate: { isRTL },
  }: GContextTypes = useContext(GlobalContext);

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Supplier Contract #${row?.docNo}`,
    removeAfterPrint: true,
  });

  if (!row) return null;

  const supplier = suppliers?.find((s: any) => s._id === row.supplierId);

  const printData = {
    ...row,
    supplier,
    suppvalue: supplier,
    terms: row?.title,
    isRTL,
  };

  const title = isRTL
    ? `عقد مورد رقم: ${row?.docNo}`
    : `Supplier Contract #${row?.docNo}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 10,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{title}</span>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <PrintDownloadSupplier
          company={company}
          printData={printData}
          componentRef={componentRef}
          handleReactPrint={handleReactPrint}
          isRTL={isRTL}
          no={row?.docNo}
          isNew={false}
        />
        <Box mt={2}>
          <SupplierContractPrint
            company={company}
            printData={printData}
            ref={componentRef}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PopupSupplierFormView;
